import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Layout({ usuario, onLogout, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { path: '/facturas', icon: '📋', label: 'Facturas' },
    { path: '/clientes', icon: '👥', label: 'Clientes' },
    { path: '/furgones', icon: '🚛', label: 'Furgones' },
    { path: '/auditoria', icon: '🔍', label: 'Auditoría' },
  ];

  if (usuario?.rol !== 'empleado') {
    navItems.push({ path: '/', icon: '📊', label: 'Dashboard' });
    navItems.push({ path: '/pagos', icon: '💰', label: 'Pagos' });
    navItems.push({ path: '/reportes', icon: '📈', label: 'Reportes' });
    navItems.push({ path: '/usuarios', icon: '⚙️', label: 'Usuarios' });
  }

  const roles = { superadmin: 'Super Admin', admin: 'Administrador', empleado: 'Empleado' };

  const isMobile = window.innerWidth < 768;

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#f1f5f9' }}>

      {/* Overlay móvil */}
      {sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99 }} />
      )}

      {/* Sidebar */}
      <div style={{
        position: 'fixed', left: 0, top: 0, bottom: 0, width: 260,
        background: '#0d2461', display: 'flex', flexDirection: 'column', zIndex: 100,
        transform: isMobile ? (sidebarOpen ? 'translateX(0)' : 'translateX(-100%)') : 'translateX(0)',
        transition: 'transform 0.25s ease',
        boxShadow: sidebarOpen ? '4px 0 20px rgba(0,0,0,0.3)' : 'none'
      }}>
        {/* Header */}
        <div style={{ padding: '20px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'white' }}>🚢 Embarque Oriental</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>Sistema de Gestión</div>
          </div>
          {isMobile && (
            <button onClick={() => setSidebarOpen(false)}
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', fontSize: 20, cursor: 'pointer' }}>×</button>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, overflowY: 'auto', padding: '12px 0' }}>
          <div style={{ padding: '8px 20px 4px', fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.35)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Menú</div>
          {navItems.map(item => (
            <div key={item.path}
              onClick={() => { navigate(item.path); setSidebarOpen(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: 10, padding: '12px 20px',
                color: location.pathname === item.path ? 'white' : 'rgba(255,255,255,0.7)',
                background: location.pathname === item.path ? 'rgba(255,255,255,0.12)' : 'transparent',
                borderLeft: location.pathname === item.path ? '3px solid #cc0000' : '3px solid transparent',
                cursor: 'pointer', fontSize: 14, transition: 'all 0.2s'
              }}>
              <span style={{ fontSize: 18, width: 24, textAlign: 'center' }}>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div style={{ padding: '16px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <div style={{ width: 38, height: 38, background: '#cc0000', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: 'white', fontSize: 16, flexShrink: 0 }}>
              {usuario?.nombre?.[0] || 'A'}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'white', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{usuario?.nombre}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)' }}>{roles[usuario?.rol]}</div>
            </div>
          </div>
          <button onClick={onLogout} style={{
            width: '100%', padding: '9px', background: 'rgba(255,255,255,0.08)',
            color: 'rgba(255,255,255,0.7)', border: 'none', borderRadius: 6,
            fontSize: 13, cursor: 'pointer', fontFamily: 'inherit'
          }}>🚪 Cerrar Sesión</button>
        </div>
      </div>

      {/* Main */}
      <div style={{ marginLeft: isMobile ? 0 : 260, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>

        {/* Topbar */}
        <div style={{
          background: 'white', borderBottom: '1px solid #e2e8f0',
          padding: '0 16px', height: 60, display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50,
          flexShrink: 0
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {isMobile && (
              <button onClick={() => setSidebarOpen(true)}
                style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#0d2461', padding: 4 }}>☰</button>
            )}
            <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0d2461', margin: 0 }}>
              {navItems.find(n => n.path === location.pathname)?.label || 'Dashboard'}
            </h1>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: '#16a34a', fontWeight: 600 }}>
            <span style={{ width: 7, height: 7, background: '#16a34a', borderRadius: '50%', display: 'inline-block' }}></span>
            En línea
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? 12 : 24 }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;